import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import OverlayViewModelType from '@/ViewModels/Controls/OverlayViewModel';
import Utilities from '../Utility/Utilities';

export default class Overlay extends Control {

    protected jQueryControl: JQuery;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.TooltipExt>;

    public constructor(protected viewModel: OverlayViewModelType, private element?: JQuery) {
        super(viewModel, element);
        
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            kendoTooltip: {
                animation: false,

                content: this.viewModel.content,

                position: this.viewModel.position,

                showAfter: this.viewModel.showAfter,

                showOn: (() => {
                    let result = '';

                    if (this.viewModel.isShownOnClick === true) {
                        result += ' click';
                    }

                    if (this.viewModel.isShownOnHover === true) {
                        result += ' mouseenter';
                    }

                    return result;
                })(),

                autoHide: this.viewModel.isAutoHide,

                filter: this.viewModel.filter,

                callout: this.viewModel.showCallout,

                widget: this.widget
            }
        });

        if (this.viewModel.filter) {
            this.addEventHandler('click', this.jQueryControl, () => {
                // Kendo berechnet die Position falsch (IE), daher muss sie hier gesetzt werden
                this.repositionOverlay(this.widget());

                if (this.viewModel.dontCloseOnClick) {
                    this.viewModel.dontCloseOnClick = false;
                    return;
                }
                
                if (this.viewModel.isVisible() === true) {
                    this.widget().hide();
                }
            }, this.viewModel.filter);
        }

        this.addEventHandler('resize', $(window), Utilities.debounce((event: JQuery.ResizeEvent) => this.onWindowResize(), 200));

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: kendo.ui.TooltipExt): void {
        let oldInitPopup = widget._initPopup;
        widget._initPopup = () => {
            oldInitPopup.call(this.widget());

            if (this.viewModel.isClosedOnClick === true) {
                this.widget().popup.element.on('click', () => {
                    widget.hide();
                });
            };

            this.applyBindings(this.widget().popup.element, {
                controlName: 'overlay',

                technicalName: this.viewModel.technicalName,

                loader: this.viewModel.isBusy,

                controlIdent: this.identifier,

                locator: this.viewModel.locator
            });
        };

        widget.bind('show', () => {
            if (this.viewModel == null || this.viewModel.isDisposed !== false) {
                return;
            }

            if (this.viewModel.isVisible() === false) {
                widget.hide();
            }

            this.viewModel.dontCloseOnClick = true;
        });

        this.defineSubscription(this.viewModel.isVisible, (isVisible: boolean) => {
            if (isVisible === false) {
                this.viewModel.isVisible(true);
                widget.hide();
            }
        });
    }

    protected repositionOverlay(widget: kendo.ui.TooltipExt) {
        if (!widget || !widget.content) {
            return;
        }

        let $lv = $('[data-view="ListView"]');
        if ($lv.length > 0) {
            let lvWidth = $lv.width();
            let lvPositionLeft = $lv.position()["left"];
            let $kendoContainer = widget.content.closest('.k-animation-container');
            let kendoKontainerWidth = $kendoContainer.width();

            let positionLeftUpdate = (lvPositionLeft + lvWidth - kendoKontainerWidth - 50) + "px";
            let positionLeft = $kendoContainer.css("left");

            // reposition if this caluluation is by at least 50pxs better then what kendo did calculate
            let diff = Math.abs(parseInt(positionLeftUpdate) - parseInt(positionLeft));
            if (diff > 50) {
                $kendoContainer.css("left", positionLeftUpdate);
            }
        }
    }

    public onWindowResize() {
        this.repositionOverlay(this.widget());
    }
}

ComponentManager.setControl('Overlay', Overlay, 'RADPresentation.HTMLClient.DefaultViewExtensions');